import ScopeConstants from "constants/ScopeConstants"

export const CostRateScope = {
    key: ScopeConstants.COST_RATE,
    selector: (state) => state.costRate,
    tokenSelector: (state) => state.authentication.token,
    fetchEndpoint: "/api/ChargeRate/Cost/Rates/",
    updateEndpoint: "/api/ChargeRate/Update/",
    deleteEndpoint: "/api/ChargeRate/Delete/"
}